export default __webpack_public_path__ + "static/media/dogmap_logo_2048_white_transparent.9cb0c0e9.png";